import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import getSetDataService from '../../../../shared/common-utilities/services/getSetDataService.jsx';
import InspectionIcon from './../../../../shared/common-utilities/utils/InspectionIcon';
import NotePinIcon from './../../../../shared/common-utilities/utils/NotePinIcon';
import StackIcon from '../../../../shared/common-utilities/utils/StackIcon.jsx';
import { IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import Add from '@mui/icons-material/Add.js';


let service = getSetDataService();

const CustomScheduleEvent = (props) => {
    const { data, myEvents, iconActive, dropOnScheduleEvent, visibleOverlappedEvents, hiddenOverlappedEvents,onShowEventTooltip,onShowHideOverlappedEvents } = props
    data.style = { background: service.getActionColor(data?.original), color: '#000' }
    const overlappingIds = service.checkEventOverlap(data.original, [...myEvents, ...hiddenOverlappedEvents]).map(event => event.id);
    const visibleOverlappedIds = visibleOverlappedEvents.map(event => event.id);

    if (data.original.isRemark) {
        return (
            <div style={{ pointerEvents: 'none' }}>
                 <div className='infoicon-block top5 right20' style={{pointerEvents: 'all'}}>
                        {/* <Tooltip title="Show Details"> */}
                            <IconButton style={{ margin: '0px', padding: '0px' }} onClick={(e)=> onShowEventTooltip()} >
                                <InfoIcon color='primary' sx={{ fontSize: '16px' }} />
                            </IconButton>
                        {/* </Tooltip>       */}
                    </div>
                <NotePinIcon />
            </div>
        )
    } else if (data.original.isAgendaItem) {
        return (
            <div className="md-custom-event-cont stylehold" >
                <div style={{ padding: '5px', display: 'flex', alignItems: 'center', pointerEvents: 'none' }}>
               
                    <InspectionIcon className="filter-dark" />
                    <div style={{ fontWeight: 'bold', color: '#486776', marginLeft: '5px' }} className='font12'>
                        {data.original?.agendaCodeType && !data.original.agendaCodeType.startsWith('_') && data.original.agendaCodeType}
                    </div>
                    <div className='infoicon-block top5' style={{pointerEvents: 'all'}}>
                        {/* <Tooltip title="Show Details"> */}
                            <IconButton style={{ margin: '0px', padding: '0px' }} onClick={(e)=> onShowEventTooltip()} >
                                <InfoIcon color='primary' sx={{ fontSize: '16px' }} />
                            </IconButton>
                        {/* </Tooltip>       */}
                    </div>
                </div>
            </div>)
    } else if (data.original.isoutOfTimeEvent) {
        return (
            <div style={{ pointerEvents: 'none' }}><ArrowRightIcon /></div>
        )
    } else if (data.original.isDummyEvent) {
        return (
            <div className={'dashed-line'} style={{ lineHeight: '10px', pointerEvents: 'none', borderColor: service.getConnectionColor(data.original.actionCode) }}></div>
        )
    } else if (data.original.isExtraDummyEvent) {
        return (
            <div style={{ opacity: 0, height: '36px' }}></div>
        )
    } else {
        return (
            <div className={'md-custom-event-cont event-wraper action-trip-bg track' + service.getActionClass(data.original) + (data.original?.fixedActionTime ? ' fix-arrow' : '')} style={data.style}
                onDragOver={e => e.preventDefault()}
                onDrop={(e) => dropOnScheduleEvent(e, data.original)}
            >
                <div className='infoicon-block'>
                    {(data.original?.hasOverlappedEvents == true && _.uniqBy(service.checkEventOverlap(data.original, [...myEvents, ...hiddenOverlappedEvents]), 'id').length > 0) ? (
                        <>
                            {visibleOverlappedIds.some(id => overlappingIds.includes(id)) ? (
                                <>
                                {/* <Tooltip title="Show Details"> */}
                                    <IconButton style={{ margin: '0px', padding: '0px' }} onClick={(e)=> onShowEventTooltip({event:data.original},{})} >
                                        <InfoIcon color='primary' sx={{ fontSize: '16px' }} />
                                    </IconButton>
                                {/* </Tooltip> */}
                                
                                    <div className='stackicon'>
                                        <Tooltip title="Close Stack">
                                            <IconButton style={{ margin: '0px', padding: '0px' }} onClick={e => onShowHideOverlappedEvents(data.original)}>
                                                <CloseIcon color='primary' sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                            
                                </>
                            ) : (
                                <div className='add-icon'>
                                    <Tooltip title="Expand Stack">
                                        <IconButton style={{ margin: '0px', padding: '0px' }} onClick={e => onShowHideOverlappedEvents(data.original)}>
                                            <Add color='primary' sx={{ fontSize: '22px', width: '18px' }} />
                                            <span style={{ fontSize: '11px', position: 'absolute', left: '14px' }}>{_.uniqBy(service.checkEventOverlap(data.original, [...myEvents, ...hiddenOverlappedEvents]), 'id').length}</span>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            )}

                            

                        </>
                    ):(
                        <>                        
                            {/* <Tooltip title="Show Details"> */}
                                <IconButton style={{ margin: '0px', padding: '0px' }} onClick={(e)=> onShowEventTooltip({event:data.original},{})} >
                                    <InfoIcon color='primary' sx={{ fontSize: '16px' }} />
                                </IconButton>
                            {/* </Tooltip>    */}
                        </>
                    )}
                </div>

                <div className={"md-custom-event-wrapper " + (data.original?.fixedActionTime ? ' fix-arrow' : '')} style={{ padding: '5px', overflow: 'hidden', display: 'flex', alignItems: 'center' }}>
                    {(iconActive == 'driver') ? <>
                        {/* <div className='d-flex cursor-pointer'>
          {data?.currentResource.vehicleBrand == "bmw" && <Tractor2Axles />}
          {data?.currentResource.vehicleBrand == "toyota" && <BoxedTruck18Ton3Axles />}
          {data?.currentResource.vehicleBrand == "volvo" && <BoxedTruck12Ton2Axles />}
        </div> */}
                    </> : <>
                        {/* <div>
          {data?.currentResource.vehicleBrand == "bmw" && <img src={usrImg} style={{ height: "30px", borderRadius: '4px', width: "30px", verticalAlign: 'middle', marginRight: '5px' }} alt="user" />}
          {data?.currentResource.vehicleBrand == "toyota" && <img src={usrImg1} style={{ height: "30px", borderRadius: '4px', width: "30px", verticalAlign: 'middle', marginRight: '5px' }} alt="user" />}
          {data?.currentResource.vehicleBrand == "volvo" && <img src={usrImg2} style={{ height: "30px", borderRadius: '4px', width: "30px", verticalAlign: 'middle', marginRight: '5px' }} alt="user" />}
          </div> */}
                    </>}
                    <div className={'' + (data.original?.fixedActionTime ? ' fix-arrow-corner' : '')} style={{ width: '100%' }}>
                        <div className="md-custom-event-details" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            {/* <img src={faTruck} style={{ height: "15px", width: "15px", verticalAlign: 'middle', marginRight: '5px' }} alt="vehicle" /> */}
                            {/* <div className="md-custom-event-title font12 max-60-ellipsis" style={{ fontWeight: 'bold', justifyContent: 'center' }}>{data.original.tripNo}</div> */}
                            {/* <div className="md-custom-event-title font12 max-60-ellipsis " style={{ fontWeight: 'bold', paddingRight: '8px', }}>{data.original.actionCode}</div> */}
                            <div className="d-flex justify-content-center font12 " style={{ gap: '0px', alignItems: 'center', width: '100%' }}>
                                <div style={{ pointerEvents: 'none' }}>
                                    {service.getActionIcon(data.original?.actionCode)}
                                </div>

                                <div style={{ width: '100%' }}>
                                    <div className="md-custom-event-title font14 max-60-ellipsis text-uppercase" style={{ fontWeight: 'bold', justifyContent: 'center' }}>
                                        {data.original.shortCity}
                                    </div>
                                    <div className="md-custom-event-time font12">
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", width: '100%' }}>
                                            {/* {data.original?.data?.length>0 &&
                                                (<>{data.original.data[0].actionCode} [{data.original.data[0].city}]
                                                    <div style={{ border: "0px solid #014b43", width: '100px', margin: '1px 10px', padding: '1px 5px', textAlign: 'center' }}></div>
                                                    {data.original.data[1].actionCode} [{data.original.data[1].city}]</>)} */}

                                            {data.original?.data?.length > 0 && (<>
                                                {data.original?.data?.map(a => (
                                                    <>
                                                        <div className='truckitem flex0' style={{ pointerEvents: 'none', backgroundColor: 'rgba(94,229,233,1)', paddingLeft: '5px', paddingRight: '5px', minHeight: '25px', borderRadius: 4 }}>
                                                            {service.getActionIcon(a.actionCode)}
                                                            <div className='trip-action' >
                                                                <span className='place' style={{ fontWeight: 'bold', color: '#007edb' }}>{a.city}</span>
                                                                <span className='time-text ml-5'>{a.startingTime}</span>
                                                            </div>
                                                        </div>
                                                        <span className='action-gap'></span>
                                                    </>
                                                ))}
                                            </>)}
                                            {/* <div style={{ border: "1px solid #014b43", width: '100px', margin: '5px 100px', background: '#0a7367', padding: '1px 5px', textAlign: 'center' }}></div> */}
                                        </div>
                                        <div className='nowrap' style={{ backgroundColor: 'rgba(255,255,255, 0)', marginTop: '4px', border: '1px solid rgb(101 ,179 ,117 , 0%)' }}>
                                            {/* <AccessTimeIcon   sx={{marginRight:'5px',fontSize: 15, verticalAlign:'top' }} /> */}
                                            {/* {moment(data.original.start).format('H:mm')} */}
                                            {/* - {data.end} */}


                                            {/* width: (Math.min(data.original.lLForLoadingdegree || 0, 100)) + '%' , */}
                                            {!data.original?.data?.length && <div className='' style={{ textAlign: 'center', fontWeight: 'bold', paddingRight:'3px', backgroundColor: 'rgba(166, 207, 233, 0)' }}>
                                                {Math.max(Math.round((data.original.lLForLoadingdegree || 0) / 100), 0)}%
                                            </div>}
                                            {/* {(data.original.actionCode) && <div style={{ maxWidth: '100px', margin: '0px', position: 'relative', textAlign: 'center' }}>
                      <div className='truckimg'>
                        <TruckProgressIcon />
                        <div className='progress-block'>
                          <div className='progress-text' style={{ width: resCapicity + '%' }}>
                            {resCapicity}%
                          </div>
                        </div>
                      </div>
                    </div>} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* {(data.original.actionCode == 'LOAD' || data.original.actionCode == 'UNLOAD') && <div style={{ maxWidth: '100px', margin: '0px 0px 0px 5px', position: 'relative', textAlign: 'center' }}>
            <div className='truckimg'>
              <TruckProgressIcon />
              <div className='progress-block'>
                <div className='progress-text' style={{ width: resCapicity + '%' }}>
                  {resCapicity}%
                </div>
              </div>
            </div>
          </div>} */}
                    {/* {data.original?.data?.length > 0 && (
                        <div className='track ' style={{ width: '100%', maxWidth: '700px', margin: '0px 0px 0px 10px', position: 'relative', textAlign: 'center', display: 'none' }}>
                            {data.original?.data?.map(a => (
                                <div className='truckitem '>
                                    {a.actionCode == LOAD && <TruckLoadIcon />}
                                    {a.actionCode == LOADDEPOT && <TruckLoadDeportIcon />}
                                    {a.actionCode == UNLOAD && <TruckUnLoadIcon />}
                                    {a.actionCode == UNLOADDEPOT && <TruckUnLoadDeportIcon />}
                                    {a.actionCode == HOOKON && <HookoffIcon />}
                                    {a.actionCode == HOOKOF && <HookoffDelIcon />}
                                    {a.actionCode == PICKUP && <PickupIcon />}
                                    {a.actionCode == DEPOSIT && <DepositIcon />}
                                    {a.actionCode == COUPLE && <CoupleIcon />}
                                    {a.actionCode == UNCOUPLE && <UnCoupleIcon />}
                                    {a.actionCode == FERRYON && <FerryIcon />}
                                    {a.actionCode == FERRYOF && <FerryOfIcon />}
                                    {a.actionCode == CLEANING && <CleaningIcon />}
                                    {a.actionCode == BREAK && <BreakTimeIcon />}
                                    {a.actionCode == DRIVE && <DriveIcon />}
                                    <div>
                                        <span className='place'>{a.city}</span>
                                        <span className='time-text'>{a.startingTime}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )} */}
                </div>
            </div>
        )
    }
};
export default CustomScheduleEvent